/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfrastructureSitesListEmissionStatsParameter
 */
export interface InfrastructureSitesListEmissionStatsParameter {
    /**
     * 
     * @type {boolean}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    annotate: boolean;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    emissionThreshold?: number;
    /**
     * 
     * @type {Date}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    detectionStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    detectionEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    matchStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    matchEndDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InfrastructureSitesListEmissionStatsParameter
     */
    filterSites?: boolean;
}

/**
 * Check if a given object implements the InfrastructureSitesListEmissionStatsParameter interface.
 */
export function instanceOfInfrastructureSitesListEmissionStatsParameter(value: object): value is InfrastructureSitesListEmissionStatsParameter {
    if (!('annotate' in value) || value['annotate'] === undefined) return false;
    return true;
}

export function InfrastructureSitesListEmissionStatsParameterFromJSON(json: any): InfrastructureSitesListEmissionStatsParameter {
    return InfrastructureSitesListEmissionStatsParameterFromJSONTyped(json, false);
}

export function InfrastructureSitesListEmissionStatsParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfrastructureSitesListEmissionStatsParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'annotate': json['annotate'],
        'emissionThreshold': json['emission_threshold'] == null ? undefined : json['emission_threshold'],
        'detectionStartDate': json['detection_start_date'] == null ? undefined : (new Date(json['detection_start_date'])),
        'detectionEndDate': json['detection_end_date'] == null ? undefined : (new Date(json['detection_end_date'])),
        'matchStartDate': json['match_start_date'] == null ? undefined : (new Date(json['match_start_date'])),
        'matchEndDate': json['match_end_date'] == null ? undefined : (new Date(json['match_end_date'])),
        'filterSites': json['filter_sites'] == null ? undefined : json['filter_sites'],
    };
}

export function InfrastructureSitesListEmissionStatsParameterToJSON(json: any): InfrastructureSitesListEmissionStatsParameter {
    return InfrastructureSitesListEmissionStatsParameterToJSONTyped(json, false);
}

export function InfrastructureSitesListEmissionStatsParameterToJSONTyped(value?: InfrastructureSitesListEmissionStatsParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'annotate': value['annotate'],
        'emission_threshold': value['emissionThreshold'],
        'detection_start_date': value['detectionStartDate'] == null ? value['detectionStartDate'] : value['detectionStartDate'].toISOString().substring(0,10),
        'detection_end_date': value['detectionEndDate'] == null ? value['detectionEndDate'] : value['detectionEndDate'].toISOString().substring(0,10),
        'match_start_date': value['matchStartDate'] == null ? value['matchStartDate'] : value['matchStartDate'].toISOString().substring(0,10),
        'match_end_date': value['matchEndDate'] == null ? value['matchEndDate'] : value['matchEndDate'].toISOString().substring(0,10),
        'filter_sites': value['filterSites'],
    };
}

